import React, { Component } from 'react'
import PropTypes from 'prop-types'
import ClassNames from 'classnames'

import Poster from '../poster'
import Slide from '../slide'
import Slider from '../slider'
import TitleCard from '../title-card'

// move to redux???
const moduleState = {
  openedPoster: null,
}

class Shelf extends Component {
  constructor(props) {
    super(props)

    this.state = {
      posterOpened: false,
      selectedTitle: 0,
    }

    this.closePoster = this.closePoster.bind(this)
    this.handlePosterCloseClick = this.handlePosterCloseClick.bind(this)
    this.handlePosterOpenClick = this.handlePosterOpenClick.bind(this)
    this.setSelectedTitle = this.setSelectedTitle.bind(this)
  }

  closePoster() {
    this.setState({
      posterOpened: false,
    })
  }

  handlePosterCloseClick() {
    this.closePoster()

    moduleState.openedPoster = null
  }

  handlePosterOpenClick() {
    if (moduleState.openedPoster) {
      moduleState.openedPoster.closePoster()
    }

    this.setState({
      posterOpened: true,
    })

    moduleState.openedPoster = this
  }

  setSelectedTitle(titleId) {
    this.setState({
      selectedTitle: titleId,
    })
  }

  componentWillUnmount() {
    this.closePoster()
  }

  render() {
    const shelfClassNames = ClassNames({
      'shelf': true,
      'shelf--poster-open': this.state.posterOpened,
    })

    let slides = this.props.titles.map((title, index) => {
      return (
        <Slide
          id={index} // to child
          key={index}
          onPosterOpenClick={this.handlePosterOpenClick} // from child
          posterOpened={this.state.posterOpened} // to child
          selectedTitle={this.state.selectedTitle} // to child
          setSelectedTitle={this.setSelectedTitle}
        >
          <TitleCard
            artworkUrl={title.artwork.cover}
            logline={title.logline}
            name={title.name}
            videoId={title.id}
          />
        </Slide>
      )
    })

    if (this.props.maxItems) {
      slides = slides.slice(0, this.props.maxItems)
    }

    const selectedTitle = this.props.titles[this.state.selectedTitle]
    let render = null

    if (selectedTitle) {
      const meta = {
        skaters: selectedTitle.skaters,
        brands: selectedTitle.brands,
        directors: selectedTitle.directors,
        genres: selectedTitle.genres,
        year: selectedTitle.releaseDate,
        duration: selectedTitle.runtime,
      }

      render = (
        <div className={shelfClassNames}>
          <h2 className="shelf__header">
            <span className="shelf__header-text">{this.props.header}</span>
          </h2>
          <Slider
            disabled={this.props.disableSlider}
            posterOpened={this.state.posterOpened} // to child
            setSelectedTitle={this.setSelectedTitle}
            slides={slides}
          />
          <Poster
            artworkUrl={selectedTitle.artwork.poster}
            meta={meta}
            name={selectedTitle.name}
            onPosterCloseClick={this.handlePosterCloseClick}
            openPoster={this.state.posterOpened}
            selectedTitle={this.state.selectedTitle}
            setSelectedTitle={this.setSelectedTitle}
            synopsis={selectedTitle.synopsis}
            id={selectedTitle.id}
          />
        </div>
      )
    }

    return render
  }
}

Shelf.propTypes = {
  disableSlider: PropTypes.bool,
  header: PropTypes.string,
  maxItems: PropTypes.number,
  titles: PropTypes.array,
}

export default Shelf



// WEBPACK FOOTER //
// ./src/desktop/components/shelf/index.js